var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoneys(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconsax/Linear/moneys"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.07 7.32816V11.9632C18.07 14.7352 16.486 15.9232 14.11 15.9232H6.19901C5.79401 15.9232 5.40701 15.8872 5.04701 15.8062C4.82201 15.7702 4.60601 15.7072 4.40801 15.6352C3.05801 15.1312 2.23901 13.9612 2.23901 11.9632L2.23901 7.32816C2.23901 4.55616 3.82301 3.36816 6.19901 3.36816L14.11 3.36816C16.126 3.36816 17.575 4.22316 17.962 6.17616C18.025 6.53616 18.07 6.90516 18.07 7.32816Z",
    stroke: "#4DFFFF",
    strokeWidth: 1.35,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20.7709 10.0278V14.6628C20.7709 17.4348 19.1869 18.6228 16.8109 18.6228H8.89991C8.23391 18.6228 7.63091 18.5328 7.10891 18.3348C6.03791 17.9388 5.30891 17.1198 5.04791 15.8058C5.40791 15.8868 5.79491 15.9228 6.19991 15.9228H14.1109C16.4869 15.9228 18.0709 14.7348 18.0709 11.9628V7.32778C18.0709 6.90478 18.0349 6.52678 17.9629 6.17578C19.6729 6.53578 20.7709 7.74178 20.7709 10.0278Z",
    stroke: "#4DFFFF",
    strokeWidth: 1.35,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.00201 7.66993V11.6299M15.2998 7.66993V11.6299M10.1482 12.0259C10.7784 12.0259 11.3827 11.7756 11.8283 11.33C12.2739 10.8844 12.5242 10.2801 12.5242 9.64993C12.5242 9.01977 12.2739 8.41543 11.8283 7.96984C11.3827 7.52425 10.7784 7.27393 10.1482 7.27393C9.51806 7.27393 8.91371 7.52425 8.46813 7.96984C8.02254 8.41543 7.77221 9.01977 7.77221 9.64993C7.77221 10.2801 8.02254 10.8844 8.46813 11.33C8.91371 11.7756 9.51806 12.0259 10.1482 12.0259Z",
    stroke: "#4DFFFF",
    strokeWidth: 1.35,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneys);
export default __webpack_public_path__ + "static/media/moneys.8a454c1acd0d7d3575a93edd67bfb706.svg";
export { ForwardRef as ReactComponent };